
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'PopUpImages',

  data: function () {
    return {
      swiperOptions: {
        spaceBetween: 40,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,

        navigation: {
          prevEl: '.pop-up-images-navigation-prev',
          nextEl: '.pop-up-images-navigation-next',
        },
      },

      activeSlide: 0,
    };
  },

  computed: {
    isOpen: function () {
      return this.$store.state['pop-up-images']?.isOpen || false;
    },
    images: function () {
      return this.$store.state['pop-up-images']?.settings?.images || [];
    },
  },

  components: {
    Swiper,
    SwiperSlide,
  },

  watch: {
    isOpen: function () {
      if (this.isOpen) {
        this.initSlider();
        window.addEventListener('keydown', this.eventKeyPress, true);
        this.addEventClose();
      } else {
        window.removeEventListener('keydown', this.eventKeyPress, true);
        this.removeEventClose();
      }
    },
  },

  methods: {
    eventKeyPress: function (event) {
      if (event?.keyCode === 27) {
        this.closePopUp();
      }
      if (event?.keyCode === 37 && this.$refs.refSwiper?.$swiper) {
        this.$refs.refSwiper?.$swiper.slidePrev();
      }
      if (event?.keyCode === 39 && this.$refs.refSwiper?.$swiper) {
        this.$refs.refSwiper?.$swiper.slideNext();
      }
    },

    addEventClose: function () {
      const elements = document.querySelectorAll('.slider-pop-up-close');
      if (elements.length <= 0) {
        setTimeout(() => {
          this.addEventClose();
        }, 1000);
        return;
      }
      document.querySelectorAll('.slider-pop-up-close').forEach((element) => {
        element.addEventListener('click', this.closePopUp);
      });
    },
    removeEventClose: function () {
      document.querySelectorAll('.slider-pop-up-close').forEach((element) => {
        element.removeEventListener('click', this.closePopUp);
      });
    },

    initSlider: function () {
      if (!this.$refs.refSwiper?.$swiper) {
        return;
      }

      const activeSlide = this.$store.state['pop-up-images']?.settings?.activeSlide || 0;
      if (activeSlide <= 0) {
        this.activeSlide = 0;
        return;
      }

      this.activeSlide = activeSlide;
      this.$refs.refSwiper.$swiper.slideToLoop(activeSlide, 0);
    },
    changeSlide: function () {
      this.activeSlide = this.$refs.refSwiper.$swiper.realIndex;
    },

    closePopUp: function () {
      this.$store.commit('pop-up-images/close');
    },
  },
};
